
      window.__LEGAL_OS_RUNTIME_CONFIG__ = {
        firebase: {
          projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'legal-os-a659e',
          apiKey: import.meta.env.VITE_FIREBASE_API_KEY || import.meta.env.FIREBASE_API_KEY || '',
          authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'legal-os-a659e.firebaseapp.com',
          storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'legal-os-a659e.firebasestorage.app',
          messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '926514276355',
          appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:926514276355:web:72ab2a4958aa366488c636'
        }
      };
    